import { Button } from 'primereact/button';
import { Tooltip } from 'primereact/tooltip';
import { useSearchParams } from 'react-router-dom';

import { AspirationsToday } from '@/types.gql';
import { formatDateWithPattern } from '@/utils';

import { useOpuSearchContext } from '../../hooks/useOpuContext';

type Props = {
  data: AspirationsToday;
  context: {
    setShowForm: (show: boolean) => void;
  };
};

export function OpuSearchSelectButton({ data, context }: Props) {
  const { setSelectedAspiration, qcDataSubmitted } = useOpuSearchContext();
  const [params, setParams] = useSearchParams();

  const opuDate =
    params.get('date') || formatDateWithPattern(new Date(), 'MM-dd-yyyy');
  const opuSiteId = params.get('site');
  const opuTechnicianId = params.get('tech');

  const handleClick = () => {
    setSelectedAspiration(data);
    context.setShowForm(true);
    if (data) {
      const newParams = new URLSearchParams(params);
      newParams.set('id', data?.aspirationId as string);
      setParams(newParams);
    }
  };

  return (
    <>
      {!qcDataSubmitted && (
        <Tooltip target=".aspiration-select-button-wrapper" />
      )}
      <div
        className="aspiration-select-button-wrapper"
        data-pr-tooltip="Must submit QC data before selecting"
      >
        <Button
          size="small"
          severity="secondary"
          label="Select"
          className="aspiration-select-button"
          onClick={handleClick}
          disabled={
            !opuDate || !opuSiteId || !opuTechnicianId || !qcDataSubmitted
          }
        />
      </div>
    </>
  );
}
